export function isUnprocessableInvalidGroups(entity) {
    return entity.content !== undefined;
}
export var AuthState;
(function (AuthState) {
    AuthState["Allowed"] = "allowed";
    AuthState["Denied"] = "denied";
})(AuthState || (AuthState = {}));
export var GroupMemberType;
(function (GroupMemberType) {
    GroupMemberType["User"] = "user";
    GroupMemberType["Group"] = "group";
})(GroupMemberType || (GroupMemberType = {}));
